module.exports = __webpack_public_path__ + "static/img/4.a1c14932.svg";